import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BandeiraCartaoService {

  getCardBrand(cardNumber: string): any {
    const visaPattern = /^4[0-9]{12}(?:[0-9]{3})?$/;
    const mastercardPattern = /^5[1-5][0-9]{14}$|^2(?:2(?:2[1-9]|[3-9][0-9])|[3-6][0-9][0-9]|7(?:[01][0-9]|20))[0-9]{12}$/;
    const amexPattern = /^3[47]\d{13}$/;
    const dinersPattern = /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/;
    const hipercardPattern = /^(606282\d{10}(\d{3})?)|(3841\d{15})$/;
    const eloPattern = /^4011(78|79)|^43(1274|8935)|^45(1416|7393|763(1|2))|^50(4175|6699|67[0-6][0-9]|677[0-8]|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9])|^627780|^63(6297|6368|6369)|^65(0(0(3([1-3]|[5-9])|4([0-9])|5[0-1])|4(0[5-9]|[1-3][0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8]|4[1-9]|[5-8][0-9]|9[0-8])|7(0[0-9]|1[0-8]|2[0-7])|9(0[1-9]|[1-6][0-9]|7[0-8]))|16(5[2-9]|[6-7][0-9])|50(0[0-9]|1[0-9]|2[1-9]|[3-4][0-9]|5[0-8]))/;
    const cabalPattern = /^6(?:0|3|5)\d{14}$/;

    if (cardNumber.match(visaPattern)) {
      return {
        caminho: '../../assets/bandeira-cartao/visa.svg',
        id: 1
      };
    } else if (cardNumber.match(mastercardPattern)) {
      return {
        caminho: '../../assets/bandeira-cartao/mastercard.svg',
        id: 2
      };
    } else if (cardNumber.match(dinersPattern)) {
      return {
        caminho: '../../assets/bandeira-cartao/diners.svg',
        id: 3
      };
    } else if (cardNumber.match(amexPattern)) {
      return {
        caminho: '../../assets/bandeira-cartao/amex.svg',
        id: 4
      };
    } else if (cardNumber.match(hipercardPattern)) {
      return {
        caminho: '../../assets/bandeira-cartao/hipercard.svg',
        id: 5
      };
    } else if (cardNumber.match(eloPattern)) {
      return {
        caminho: '../../assets/bandeira-cartao/elo.svg',
        id: 6
      };
    } else if (cardNumber.match(cabalPattern)) {
      return {
        caminho: '../../assets/bandeira-cartao/cabal.svg',
        id: 7
      };
    } else {
      // Retorne um caminho de imagem padrão ou vazio se a bandeira não for reconhecida
      return {
        caminho: '',
        id: 0
      };
    }
  }

  getCardBrandForId(id: number): any {
    if (id == 1) {
      return {
        caminho: '../../assets/bandeira-cartao/visa.svg',
        id: 1
      };
    } else if (id == 2) {
      return {
        caminho: '../../assets/bandeira-cartao/mastercard.svg',
        id: 2
      };
    } else if (id == 3) {
      return {
        caminho: '../../assets/bandeira-cartao/diners.svg',
        id: 3
      };
    } else if (id == 4) {
      return {
        caminho: '../../assets/bandeira-cartao/amex.svg',
        id: 4
      };
    } else if (id == 5) {
      return {
        caminho: '../../assets/bandeira-cartao/hipercard.svg',
        id: 5
      };
    } else if (id == 5) {
      return {
        caminho: '../../assets/bandeira-cartao/elo.svg',
        id: 6
      };
    } else if (id == 7) {
      return {
        caminho: '../../assets/bandeira-cartao/cabal.svg',
        id: 7
      };
    } else {
      // Retorne um caminho de imagem padrão ou vazio se a bandeira não for reconhecida
      return {
        caminho: '',
        id: 0
      };
    }
  }
}
